import React from 'react';
import FormDefault from '~/components/FormDefault';
import Search from '~/components/Search';
import { Container } from './styles';
import { useRomaneio } from './hooks/useRomaneio';
import { FilterFields } from './components/FilterFields';
import { AjusteFields } from './components/AjusteFields';

export const RomaneioFornContent: React.FC = () => {
  const {
    showSearch,
    setShowSearch,
    isUpdate,
    setUpdate,
    resetFormData,
    onRowClick,
    onSave,
    handleCancel,
    onNew,
    formTela: { watch },
  } = useRomaneio();

  return (
    <Container>
      {showSearch && (
        <Search codTela={325} newData={onNew} onRowClick={onRowClick} />
      )}
      {!showSearch && (
        <FormDefault
          codTela={325}
          title="Romaneio de Fornecedor"
          codigoRegistro={[
            {
              value: watch('cod_seq_ajuste_estoque'),
              des_campo: 'Código do Ajuste',
            },
          ]}
          onSave={async () => {
            await onSave();
          }}
          isUpdate={isUpdate}
          onClearFields={resetFormData}
          onDelete={handleCancel}
          onNew={onNew}
          onReturnSearch={() => {
            setUpdate(false);
            setShowSearch(true);
          }}
          onCancel={() => {
            setUpdate(false);
            setShowSearch(true);
          }}
          isDisabledSave={isUpdate}
          labelButtonTrash="Cancelar Ajuste"
          deleteMessage="Deseja realmente cancelar o registro?"
        >
          <FilterFields />
          <AjusteFields />
        </FormDefault>
      )}
    </Container>
  );
};
